/**
 * Generated runtime TestId mirror for frontend/src/pages/ResourceDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ResourceDetailTestIds = {
  btnDeleteResource: "btn-delete-resource",
  cardResourceDetails: "card-resource-details",
  colChildDataClassification: "col-child-data-classification",
  colChildName: "col-child-name",
  colChildResourceType: "col-child-resource-type",
  colEoName: "col-eo-name",
  colEoSystem: "col-eo-system",
  colEoType: "col-eo-type",
  colProfileName: "col-profile-name",
  colProfileRisk: "col-profile-risk",
  colProfileSource: "col-profile-source",
  colProfileStatus: "col-profile-status",
  linkParentResource: "link-parent-resource",
  linkSystem: "link-system",
  resourceDetailPage: "resource-detail-page",
  sectionAccessProfiles: "section-access-profiles",
  sectionAttributes: "section-attributes",
  sectionChildren: "section-children",
  sectionEnforcementObjects: "section-enforcement-objects",
  linkAccessProfile: (profile_id: string) => `link-access-profile-${profile_id}`,
  linkAccessProfilePrefix: () => "link-access-profile-" as TestIdPrefix,
  linkAncestor: (ancestor_resource_id: string) => `link-ancestor-${ancestor_resource_id}`,
  linkAncestorPrefix: () => "link-ancestor-" as TestIdPrefix,
  linkChildResource: (child_id: string) => `link-child-resource-${child_id}`,
  linkChildResourcePrefix: () => "link-child-resource-" as TestIdPrefix,
  linkEnforcementObject: (eo_id: string) => `link-enforcement-object-${eo_id}`,
  linkEnforcementObjectPrefix: () => "link-enforcement-object-" as TestIdPrefix,
  linkEnforcementObjectSystem: (eo_id: string) => `link-enforcement-object-system-${eo_id}`,
  linkEnforcementObjectSystemPrefix: () => "link-enforcement-object-system-" as TestIdPrefix,
  linkSourceResource: (profile_id: string) => `link-source-resource-${profile_id}`,
  linkSourceResourcePrefix: () => "link-source-resource-" as TestIdPrefix
} as const;
